import {
  Maybe,
  CardType,
  CardPaperType,
  Operation,
} from '../../../__generated__/globalTypes'

import {
  CardFragment,
  cardFragmentString,
} from '../../fragments/__generated__/CardFragment'

import {
  AccountFragment,
  accountFragmentString,
} from '../../fragments/__generated__/AccountFragment'

import { planFeatureIconString } from '../../fragments/__generated__/PlanFeatureIcon'

import { featureFragmentString } from '../../fragments/__generated__/FeatureFragment'

import { storefrontString } from '../../fragments/__generated__/Storefront'

import { minimalSponsorFragmentString } from '../../fragments/__generated__/MinimalSponsorFragment'

import { stripeSubscriptionString } from '../../fragments/__generated__/StripeSubscription'

import { imageFragmentString } from '../../fragments/__generated__/ImageFragment'

import { elementFragmentString } from '../../fragments/__generated__/ElementFragment'

import { subscriptionMetadataString } from '../../fragments/__generated__/SubscriptionMetadata'

import { textFragmentFragmentString } from '../../fragments/__generated__/TextFragmentFragment'

import { expenseReloadString } from '../../fragments/__generated__/ExpenseReload'

import { elementPictureFragmentString } from '../../fragments/__generated__/ElementPictureFragment'

import { colorFragmentString } from '../../fragments/__generated__/ColorFragment'

import { panelFragmentString } from '../../fragments/__generated__/PanelFragment'

import { labeledPriceString } from '../../fragments/__generated__/LabeledPrice'

import { amountString } from '../../fragments/__generated__/Amount'

import { stripeSourceFragmentString } from '../../fragments/__generated__/StripeSourceFragment'

import { planFragmentString } from '../../fragments/__generated__/PlanFragment'

import { sendableCardImageFragmentString } from '../../fragments/__generated__/SendableCardImageFragment'

import { creditCardFragmentString } from '../../fragments/__generated__/CreditCardFragment'

import { elementTextFragmentString } from '../../fragments/__generated__/ElementTextFragment'

import { subscriptionFeaturesString } from '../../fragments/__generated__/SubscriptionFeatures'

import { planFeatureFragmentString } from '../../fragments/__generated__/PlanFeatureFragment'

import { userSettingsFragmentString } from '../../fragments/__generated__/UserSettingsFragment'

import { paragraphFragmentString } from '../../fragments/__generated__/ParagraphFragment'

import { priceString } from '../../fragments/__generated__/Price'

import { itemizedCostFragmentString } from '../../fragments/__generated__/ItemizedCostFragment'

import { bankAccountFragmentString } from '../../fragments/__generated__/BankAccountFragment'

import { sendableCardWithTemplateFragmentString } from '../../fragments/__generated__/SendableCardWithTemplateFragment'

import { sendableCardFragmentString } from '../../fragments/__generated__/SendableCardFragment'

import { addressFragmentString } from '../../fragments/__generated__/AddressFragment'

import createCardRawString from '../CreateCard.graphql'

const createCardString = [
  createCardRawString,
  cardFragmentString,
  accountFragmentString,
  planFeatureIconString,
  featureFragmentString,
  storefrontString,
  minimalSponsorFragmentString,
  stripeSubscriptionString,
  imageFragmentString,
  elementFragmentString,
  subscriptionMetadataString,
  textFragmentFragmentString,
  expenseReloadString,
  elementPictureFragmentString,
  colorFragmentString,
  panelFragmentString,
  labeledPriceString,
  amountString,
  stripeSourceFragmentString,
  planFragmentString,
  sendableCardImageFragmentString,
  creditCardFragmentString,
  elementTextFragmentString,
  subscriptionFeaturesString,
  planFeatureFragmentString,
  userSettingsFragmentString,
  paragraphFragmentString,
  priceString,
  itemizedCostFragmentString,
  bankAccountFragmentString,
  sendableCardWithTemplateFragmentString,
  sendableCardFragmentString,
  addressFragmentString,
].join('\n\n')

export type CreateCardData = {
  createCard: {
    card: CardFragment
    account: AccountFragment
  }
}

export type CreateCardVariables = {
  sendableCard?: Maybe<string>
  type?: Maybe<CardType>
  paperType?: Maybe<CardPaperType>
  card?: Maybe<string>
  sponsor?: Maybe<string>
}

export type CreateCard = Operation<CreateCardData, CreateCardVariables>

export const CreateCard = ({
  sendableCard,
  type,
  paperType,
  card,
  sponsor,
}: CreateCardVariables = {}): CreateCard => ({
  query: createCardString,
  variables: {
    sendableCard,
    type,
    paperType,
    card,
    sponsor,
  },
})
